import React, { createContext, useContext, useState, useCallback } from 'react';

const SpinnerContext = createContext();

export const useSpinner = () => {
    const context = useContext(SpinnerContext);
    if (!context) {
        throw new Error('useSpinner debe ser usado dentro de SpinnerProvider');
    }
    return context;
};

export const SpinnerProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [message, setMessage] = useState('Cargando...');

    const showSpinner = useCallback((customMessage = 'Cargando...') => {
        setMessage(customMessage);
        setIsVisible(true);
    }, []);

    const hideSpinner = useCallback(() => {
        setIsVisible(false);
    }, []);

    const value = {
        isVisible,
        message,
        showSpinner,
        hideSpinner
    };

    return (
        <SpinnerContext.Provider value={value}>
            {children}
        </SpinnerContext.Provider>
    );
};